var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelehealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2427_7917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7.5C1.27539 3.63401 4.4094 0.5 8.27539 0.5H42.2754C46.1414 0.5 49.2754 3.63401 49.2754 7.5V41.5C49.2754 45.366 46.1414 48.5 42.2754 48.5H8.27539C4.4094 48.5 1.27539 45.366 1.27539 41.5V7.5Z",
    fill: "url(#paint0_linear_2427_7917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7.5C1.27539 3.63401 4.4094 0.5 8.27539 0.5H42.2754C46.1414 0.5 49.2754 3.63401 49.2754 7.5V41.5C49.2754 45.366 46.1414 48.5 42.2754 48.5H8.27539C4.4094 48.5 1.27539 45.366 1.27539 41.5V7.5Z",
    fill: "#ECCCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2754 34.5C16.7254 34.5 16.2546 34.3042 15.8629 33.9125C15.4712 33.5208 15.2754 33.05 15.2754 32.5V20.5C15.2754 19.95 15.4712 19.4792 15.8629 19.0875C16.2546 18.6958 16.7254 18.5 17.2754 18.5H21.2754V16.5C21.2754 15.95 21.4712 15.4792 21.8629 15.0875C22.2546 14.6958 22.7254 14.5 23.2754 14.5H27.2754C27.8254 14.5 28.2962 14.6958 28.6879 15.0875C29.0796 15.4792 29.2754 15.95 29.2754 16.5V18.5H33.2754C33.8254 18.5 34.2962 18.6958 34.6879 19.0875C35.0796 19.4792 35.2754 19.95 35.2754 20.5V32.5C35.2754 33.05 35.0796 33.5208 34.6879 33.9125C34.2962 34.3042 33.8254 34.5 33.2754 34.5H17.2754ZM23.2754 18.5H27.2754V16.5H23.2754V18.5ZM24.2754 27.5V30.5H26.2754V27.5H29.2754V25.5H26.2754V22.5H24.2754V25.5H21.2754V27.5H24.2754Z",
    fill: "#9F00FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2427_7917",
    x: 0.275391,
    y: 0.5,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2427_7917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2427_7917",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2427_7917",
    x1: 25.2754,
    y1: 0.5,
    x2: 25.2754,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelehealthIcon);
export default __webpack_public_path__ + "static/media/telehealth-icon.dcefb7e10edc33c3af9d33804c990c47.svg";
export { ForwardRef as ReactComponent };